import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import PushService from 'cio/services/push';
import AndroidController from './controller';
import Transition from '@ember/routing/-private/transition';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class AndroidRoute extends Route {
  @service push!: PushService;
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'Android',
      path: 'actions.push.android',
    };
  }

  async setupController(controller: AndroidController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    await this.loadCredentials();

    let isConfigured = this.isPlatformConfigured();
    let showDisable = false;
    if (isConfigured) {
      showDisable = !this.areAllPlatformsFCM();
    }

    controller.set('isConfigurationEmpty', !isConfigured);
    controller.set('showDisable', showDisable);
    this.confirmChanges.register(controller, this);
  }

  resetController(controller: AndroidController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.set('isDirty', false);
      controller.set('isEditing', false);
    }
  }

  async loadCredentials() {
    await this.push.loadCredentials.perform();
  }

  isPlatformConfigured() {
    let { platforms } = this.push;
    return platforms.some((p: any) => p.key === 'android');
  }

  areAllPlatformsFCM() {
    let { platforms } = this.push;
    return platforms.length > 1 && platforms.every((platform: any) => platform.provider === 'fcm');
  }
}
